"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconUserSquareSolid = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M35 36.44a13.72 13.72 0 1 0-13.72-13.71A13.73 13.73 0 0 0 35 36.44zM35 39.65c-21.36 0-19.75 12.94-22.17 30.35h44.34C54.75 52.59 56.36 39.65 35 39.65z"
  })),
  height: undefined,
  width: undefined
});
IconUserSquareSolid.displayName = 'IconUserSquareSolid';
var _default = IconUserSquareSolid;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/user-square-solid.js
// module id = 629
// module chunks = 0